import { useWizard } from "react-use-wizard";
import sellSteps from "../sellSteps";
import BaseStep from "../../../../../../shared/wizard/steps/baseStep";

const DoNotKnowPrice_3 = () => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(sellSteps.doNotKnowPrice.step_2);
  };

  const handleYesStep = () => {
    goToStep(sellSteps.doNotKnowPrice.swap.step_1);
  };

  const handleNoStep = () => {
    goToStep(sellSteps.doNotKnowPrice.sell.step_1);
  };

  return (
    <BaseStep
      text="Получить предложение по выкупу?"
      yesStep={handleYesStep}
      noStep={handleNoStep}
      prevStep={handlePrevStep}
    ></BaseStep>
  );
};

export default DoNotKnowPrice_3;
